module.exports = __webpack_public_path__ + "static/media/flask-poison.ef22a0c4.svg";